import { ReviewGroupsMediaFilter, UserReviewGroupsSort } from '@web/gql/graphql'

enum MediaQueryFilterEnum {
  ALL = 'all',
  WITHOUT_MEDIA = 'without',
  WITH_MEDIA = 'with',
}

export const extractMediaQuery = (mediaQuery?: string | string[]): ReviewGroupsMediaFilter | undefined => {
  if (typeof mediaQuery !== 'string') return undefined

  if (mediaQuery.toLocaleLowerCase() === MediaQueryFilterEnum.ALL) return ReviewGroupsMediaFilter.All

  if (mediaQuery.toLocaleLowerCase() === MediaQueryFilterEnum.WITHOUT_MEDIA) return ReviewGroupsMediaFilter.WithoutMedia

  if (mediaQuery.toLocaleLowerCase() === MediaQueryFilterEnum.WITH_MEDIA) return ReviewGroupsMediaFilter.WithMedia

  return undefined
}

enum SortQueryFilterEnum {
  RECENT = 'recent',
  POPULAR = 'popular',
}

export const extractSortQuery = (sortQuery?: string | string[]): UserReviewGroupsSort | undefined => {
  if (typeof sortQuery !== 'string') return undefined

  if (sortQuery.toLocaleLowerCase() === SortQueryFilterEnum.RECENT) return UserReviewGroupsSort.VisitDateTimeDesc

  if (sortQuery.toLocaleLowerCase() === SortQueryFilterEnum.POPULAR) return UserReviewGroupsSort.ViewCountDesc

  return undefined
}
